import { create } from "zustand";
import {
  getTradingAssets,
  getUserTransactionHistory,
} from "../services/digitalWalletService";

export const useAssetStore = create((set) => ({
  cryptoAssets: [],
  loadingAssets: false,
  errorAssets: null,

  fetchAssets: async () => {
    set({ loadingAssets: true, errorAssets: null });
    try {
      const response = await getTradingAssets("Crypto");
      set({ cryptoAssets: response.data.data, loadingAssets: false });
    } catch (err) {
      set({ errorAssets: err.message, loadingAssets: false });
    }
  },
}));

export const usePairStore = create((set) => ({
  pairObject: {},
  setPairObject: (pairData) => set({ pairObject: pairData }),
}));

export const useUserTransactionStore = create((set) => ({
  userTransactions: [],
  loadingUserTr: false,
  errorUserTr: null,

  fetchUserTransactions: async (userId) => {
    if (!userId) return;

    set({ loadingUserTr: true, errorUserTr: null });

    try {
      let allResults = [];

      const firstPageData = await getUserTransactionHistory(userId);
      const { totalPages, results } = firstPageData.data.data;

      allResults = [...results];

      if (totalPages > 1) {
        const pageRequests = [];
        for (let i = 2; i <= totalPages; i++) {
          pageRequests.push(getUserTransactionHistory(userId, i));
        }

        const responses = await Promise.all(pageRequests);
        responses.forEach((response) => {
          allResults.push(...response.data.data.results);
        });
      }

      set({ userTransactions: allResults, loadingUserTr: false });
    } catch (error) {
      set({ errorUserTr: error.message, loadingUserTr: false });
    }
  },

  resetUserTransactions: () => set({ userTransactions: [], errorUserTr: null }),
}));
